import { all } from 'redux-saga/effects';

import { fetchAuditSaga } from './fetchAudit';

export default function* () {
    yield all([fetchAuditSaga()]);
}
